const messages = {
    root: {
        pageTitle: 'Administracja',
        menuTitle: 'Administracja'
    },
    roomReservations: {
        pageTitle: 'Rezerwacja salek',
        menuTitle: 'Rezerwacja salek',
        legacyPageTitle: 'Rezerwacja salek (stary widok)',
        legacyMenuTitle: 'Rezerwacja salek (stary widok)',
        pages: {
            main: {
                title: 'Salki',
                calendar: {
                    prev: 'Poprzedni',
                    next: 'Następny',
                    today: 'Dziś',
                    week: 'Tydzień',
                    day: 'Dzień',
                    twoDays: '2 dni',
                    rooms: 'Salki',
                    tooltip: {
                        date: 'Termin',
                        reservedBy: 'Rezerwujący',
                        onBehalfOf: 'W imieniu'
                    }
                },
                noRoomPermission: 'Nie masz uprawnień do rezerwacji salki',
                roomAccess: 'Dostęp do salki'
            },
            roomAccessDialog: {
                title: 'Dostęp do salki: {room}',
                users: 'Uprawnieni użytkownicy',
                publicRoom: 'Brak przypisanych użytkowników - salkę może zarezerwować każdy.',
                restrictedRoom: 'Salkę mogą zarezerwować tylko przypisani użytkownicy.',
                userSearchPlaceholder: 'Wpisz treść aby odnaleźć użytkownika.',
                userSearching: 'Trwa wyszukiwanie...',
                userNotFound: 'Nie znaleziono',
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            dialog: {
                delete: {
                    title: 'Usuwanie rezerwacji',
                    content: 'Czy na pewno chcesz usunąć rezerwację?',
                    confirm: 'Usuń',
                    contentFollowing:
                        'Czy na pewno chcesz usunąć ten termin i wszystkie kolejne terminy cyklu? Wcześniejsze terminy pozostaną bez zmian.',
                    confirmFollowing: 'Usuń wszystkie'
                },
                cycleScope: {
                    title: 'Edycja rezerwacji cyklicznej',
                    content:
                        'Czy zastosować zmiany także do kolejnych terminów w cyklu? Wcześniejsze terminy pozostaną bez zmian.',
                    onlyThis: 'Tylko ten termin',
                    following: 'Ten i kolejne',
                    cancel: 'Anuluj'
                },
                create: {
                    title: 'Tworzenie rezerwacji: {date}',
                    reservationName: 'Nazwa rezerwacji',
                    room: 'Salka',
                    roomNotFound: 'Nie znaleziono typu salki',
                    length: 'Długość rezerwacji',
                    term: 'Termin: {term}',
                    allDay: 'Rezerwacja na cały dzień',
                    onBehalfOf: 'Rezerwuję w imieniu',
                    cyclic: 'Rezerwacja cykliczna (co tydzień)',
                    cycleRepetitions: 'Liczba powtórzeń',
                    cycleEndDate: 'Data zakończenia cyklu: {date}',
                    userSearchPlaceholder: 'Wpisz treść aby odnaleźć użytkownika.',
                    userSearching: 'Trwa wyszukiwanie...',
                    userNotFound: 'Nie znaleziono',
                    cancel: 'Anuluj',
                    save: 'Zapisz',
                    validation: {
                        nameMinLength: 'Nazwa rezerwacji musi zawierać minimum 2 znaki.',
                        nameRequired: 'Nazwa rezerwacji jest wymagana.',
                        roomRequired: 'Salka jest wymagana.',
                        cycleRepetitionsRequired: 'Liczba powtórzeń jest wymagana.',
                        cycleRepetitionsRange: 'Liczba powtórzeń musi być liczbą całkowitą od 1 do {max}.'
                    }
                },
                edit: {
                    title: 'Edycja rezerwacji: {date}',
                    reservedBy: 'Rezerwujący',
                    onBehalfOf: 'W imieniu',
                    startTime: 'Godzina rozpoczęcia',
                    delete: 'Usuń',
                    deleteFollowing: 'Usuń wszystkie',
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            }
        },
        services: {
            errors: {
                fetchFailed: 'Pobranie rezerwacji nie powiodło się.',
                fetchOneFailed: 'Pobranie danych do rezerwacji {id} nie powiodło się.',
                createFailed: 'Dodanie rezerwacji nie powiodło się.',
                updateFailed: 'Edycja rezerwacji nie powiodła się.',
                deleteFailed: 'Usunięcie rezerwacji nie powiodło się.',
                fetchTypesFailed: 'Pobranie salek nie powiodło się.',
                cycleCollision: 'Kolizja rezerwacji: {dates}',
                updateAllowedUsersFailed: 'Zapis listy uprawnionych do salki nie powiódł się.'
            },
            success: {
                created: 'Rezerwacja została dodana.',
                updated: 'Rezerwacja została zedytowana.',
                deleted: 'Rezerwacja została usunięta.',
                allowedUsersUpdated: 'Lista uprawnionych do salki została zapisana.'
            }
        }
    },
    roomReservationsNew: {
        pages: {
            main: {
                title: 'Rezerwacje salek',
                newReservation: 'Nowa rezerwacja',
                previousRange: 'Poprzedni zakres',
                nextRange: 'Następny zakres',
                viewLabel: 'Zakres widoku',
                rooms: 'Salka',
                more: '+{count} więcej',
                noReservations: 'brak',
                reservationsCount: '{count} rez.',
                addReservation: 'Dodaj rezerwację: {room}, {date}',
                termTaken: 'Termin jest zajęty',
                termChanged: 'Zmieniono termin rezerwacji',
                loading: 'Ładowanie rezerwacji',
                loadError: 'Nie udało się pobrać rezerwacji.',
                retry: 'Spróbuj ponownie',
                undo: 'Cofnij',
                summary: 'Liczba rezerwacji w widoku: {count}',
                legend: {
                    blocked: 'Rezerwacja innej osoby (tylko podgląd)',
                    cyclic: 'Rezerwacja cykliczna',
                    businessHours: 'Godziny pracy {from}–{to}'
                }
            }
        }
    },
    users: {
        pageTitle: 'Użytkownicy',
        menuTitle: 'Użytkownicy',
        list: {
            title: 'Lista użytkowników',
            headers: {
                username: 'Nazwa użytkownika',
                fullName: 'Imię i nazwisko',
                email: 'E-mail',
                department: 'Dział',
                lastLogin: 'Ostatnie logowanie',
                isActive: 'Czy aktywny?',
                actions: 'Akcje'
            },
            filters: {
                departmentPlaceholder: 'Działy...',
                search: 'Szukaj...'
            },
            actions: {
                add: 'Dodaj użytkownika',
                editTooltip: 'Edycja'
            }
        },
        dialogs: {
            create: {
                title: 'Tworzenie nowego użytkownika'
            },
            update: {
                title: 'Edycja użytkownika'
            },
            fields: {
                username: 'Nazwa użytkownika',
                email: 'E-mail',
                firstName: 'Imię',
                lastName: 'Nazwisko',
                password: 'Nowe hasło',
                confirmPassword: 'Powtórz hasło',
                copyFromUser: 'Kopiuj z innego użytkownika',
                copyFromUserUser: 'Wybierz użytkownika',
                phoneNumber: 'Numer telefonu',
                department: 'Dział',
                subDepartment: 'Wydział',
                position: 'Stanowisko',
                squad: 'Brygada',
                supervisor: 'Przełożony',
                costCenterNumber: 'MPK',
                machines: 'Maszyny:',
                roles: 'Role w systemie:',
                mayHaveSubordinate: 'Może mieć podwładnych',
                isActive: 'Aktywne',
                remoteAccess: 'Dostęp zdalny',
                canLoginWithRogerCard: 'Logowanie kartą Roger',
                rogerCardNumber: 'Numer karty Roger',
                testAccount: 'Konto testowe'
            },
            hints: {
                password: 'Ilość znaków 8-20, duża litera, cyfra oraz znak specjalny.'
            },
            placeholders: {
                machines: 'Wybierz maszyny',
                roles: 'Wybierz role'
            },
            search: {
                userPlaceholder: 'Wpisz treść aby odnaleźć użytkownika.',
                supervisorPlaceholder: 'Wpisz treść aby odnaleźć przełożonego.',
                searching: 'Trwa wyszukiwanie...',
                notFound: 'Nie znaleziono'
            },
            validations: {
                usernameRequired: 'Nazwa użytkownika jest wymagana.',
                emailRequired: 'Adres e-mail jest wymagany.',
                emailInvalid: 'Proszę podać poprawny adres e-mail.',
                firstNameRequired: 'Imię jest wymagane.',
                lastNameRequired: 'Nazwisko jest wymagane.',
                passwordRequired: 'Hasło jest wymagane.',
                confirmPasswordRequired: 'Powtórzenie hasła jest wymagane.',
                passwordRequirements: 'Hasło musi zawierać od 8 do 20 znaków, wielką literę, cyfrę oraz znak specjalny.',
                passwordsNotSame: 'Hasła nie są identyczne.'
            }
        },
        notifications: {
            fetchUsersError: 'Pobranie listy użytkowników nie powiodło się.',
            fetchUserError: 'Pobranie danych użytkownika nie powiodło się.',
            fetchCostCenterNumbersError: 'Pobranie listy MPK nie powiodło się.',
            userCreated: 'Dodano nowego użytkownika.',
            userCreationError: 'Dodanie nowego użytkownika nie powiodło się.',
            userUpdated: 'Użytkownik został zedytowany.',
            userUpdateError: 'Edycja użytkownika nie powiodła się.',
            fetchProductionDepartmentsError: 'Pobranie działów nie powiodło się.',
            fetchStopCardProductionDepartmentsError: 'Pobranie działów dla kart stop nie powiodło się.',
            fetchUserPositionsError: 'Pobranie stanowisk nie powiodło się.',
            fetchUserSquadsError: 'Pobranie brygad nie powiodło się.',
            fetchUserRolesError: 'Pobranie ról użytkowników nie powiodło się.',
            searchUsersError: 'Szukanie użytkowników nie powiodło się.',
            searchActiveUsersError: 'Szukanie aktywnych użytkowników nie powiodło się.'
        }
    },
    costCenterNumbers: {
        pageTitle: 'Baza MPK',
        menuTitle: 'Baza MPK',
        list: {
            title: 'Baza MPK',
            headers: {
                code: 'Kod',
                description: 'Opis',
                actions: 'Akcje'
            },
            filters: {
                search: 'Szukaj...'
            },
            actions: {
                sync: 'Synchronizuj MPK z XL',
                editTooltip: 'Edytuj'
            }
        },
        dialog: {
            edit: {
                title: 'Edycja MPK'
            },
            fields: {
                code: 'Kod',
                description: 'Opis'
            },
            actions: {
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            validation: {
                codeRequired: 'Proszę podać kod MPK.',
                codeInteger: 'Proszę podać wartość kod MPK jako liczbę naturalną.'
            }
        },
        services: {
            errors: {
                fetchFailed: 'Pobranie listy MPK nie powiodło się.',
                updateFailed: 'Edycja MPK nie powiodła się.',
                syncFailed: 'Nie udało się zsynchronizować kodów MPK'
            },
            success: {
                updated: 'MPK został zedytowany.',
                synced: 'Synchronizacja MPK zakończona pomyślnie.'
            }
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
